exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#forgot-password-modal a,#login-modal a{cursor:pointer}#forgot-password-modal .modal-dialog,#login-modal .modal-dialog{max-width:400px;margin:0 auto}#forgot-password-modal .alert.alert-danger a,#login-modal .alert.alert-danger a{color:#fff}", ""]);

